export class PremiumExpendableCouponStore {
  constructor(public id: string, public name: string) {}
}
